import { actions as makePaymentActions } from './makePayment';
import { actions as paymentDetailsActions } from './paymentDetails';

export const actions = {
  ...makePaymentActions,
  ...paymentDetailsActions,
};
